import React, { Component } from 'react';

import i18n from 'i18n-react';
import renderHTML from 'react-render-html';

import ContentHeader from 'components/ContentHeader';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const trackShare = () => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(
        appId,
        email,
        'collateral',
        'message-center',
        `${window.location.href}/main/message-center`,
        'message-center',
      ).then(() => {});
    });
  });
};

// TODO: Commented out unused code [parseMessageDates] during Translations update. Remove during future cleanup if no longer needed.
// const parseMessageDates = (messages) => {
//   const validTypes = ['second', 'minute', 'day', 'month', 'year'];
//   const [{ date }] = messages;
//   if (date) {
//     const newMessages = messages;
//     return newMessages.map((message) => {
//       const newMessage = message;
//       const [number] = message.date.match(new RegExp('([0-9]*)', 'g'));
//       const [type] = message.date.match(new RegExp('(seconds?|minutes?|hours?|days?|months?|years?)', 'g'));
//       if (validTypes.some((t) => t.startsWith(type))) {
//         newMessage.date = i18n.translate(`messageCenter.${type}Ago`, { number });
//       }
//       return newMessage;
//     });
//   }
//   return messages;
// };

const currentDateFormat = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

export default class MessageCenter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messages: [],
      activeMessage: {},
    };
  }

  UNSAFE_componentWillMount() {
    StorageHandler.save(storageKeys.lastCheckedMessage, currentDateFormat(new Date()));
    DataHandler.getLanguage().then((lang) => {
      const locale = `${lang.langFile.toLowerCase()}_${lang.langFile
        .toUpperCase()
        .replace('PT', 'BR')
        .replace('KO', 'KR')}`;

      DataHandler.requestWithId((appId) => APIHandler.getMessage(appId, locale)).then((res) => {
        this.setState({
          messages: res,
          activeMessage: Object.values(res)[0],
        });
      });
    });
    trackShare();
  }

  setActive(activeMessage) {
    this.setState({ activeMessage });
  }

  text(currentMessage, strip) {
    const { activeMessage } = this.state;
    let { message } = activeMessage;
    if (currentMessage) {
      message = currentMessage;
    }

    const indices = [message.indexOf('.'), message.indexOf('!'), message.indexOf('?')];
    indices.forEach((index, i) => {
      if (index === -1) {
        indices[i] = Infinity;
      }
    });
    if (strip) {
      return message;
    }
    message = message.replace(/<\/?[^>]+(>|$)/g, '');
    return message.split('.')[0];
  }

  // TODO: Commented out unused code [content()] during Translations update. Remove during future cleanup if no longer needed.
  // content(currentMessage) {
  //   const { activeMessage } = this.state;
  //   let { message } = activeMessage;
  //   if (currentMessage) {
  //     message = currentMessage;
  //   }

  //   return message;
  // }

  render() {
    const { messages, activeMessage } = this.state;
    const { message } = activeMessage;

    const messageItems = Object.values(messages).map((item, i) => {
      const key = i;
      return (
        <li key={key} className={message === item.message ? 'active' : ''}>
          <div
            role="button"
            id={`${key}_listItem`}
            onClick={() => this.setActive(item)}
            onKeyPress={() => this.setActive(item)}
            className="message__inbox--container"
            tabIndex={-1}
          >
            <div className="message__inbox--text">
              {renderHTML(this.text(item.message))}
              <p>{item.date}</p>
            </div>
          </div>
        </li>
      );
    });

    return (
      <div className="contentContainer">
        <ContentHeader header={i18n.translate('nav.messages')} />
        <div className="message__Container">
          <div className="message__Grid">
            {messages.length > 0 ? (
              <div className="message__Inbox">
                <ul>{messageItems}</ul>
              </div>
            ) : (
              <p className="subtitle">{i18n.translate('general.noMessages')}</p>
            )}
            {activeMessage !== undefined && messages.length > 0 && (
              <div className="message__Content">
                {Object.keys(activeMessage).length > 0 && (
                  <div>
                    {activeMessage.img !== '' && (
                      <a
                        data-fancybox={activeMessage.img}
                        data-src={activeMessage.img}
                        href={activeMessage.img}
                        key={activeMessage.img}
                      >
                        <img src={activeMessage.img} alt="display" />
                      </a>
                    )}
                    <p>{renderHTML(this.text(null, true))}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
